/**
 * Subscription utility functions and display helpers
 */

export const getSubjectDisplayName = (subject) => {
  const names = {
    math: "Mathematics",
    science: "Science",
    english: "English Grammar",
    hindi: "Hindi Vyakaran",
    physics: "Physics",
    chemistry: "Chemistry",
    biology: "Biology"
  };
  return names[subject?.toLowerCase()] || subject;
};

export const getDurationLabel = (duration) => {
  const labels = {
    monthly: "Monthly",
    "3_months": "3 Months",
    "6_months": "6 Months"
  };
  return labels[duration] || duration;
};

export const getStatusBadgeColor = (status) => {
  switch (status) {
    case "active":
      return "bg-emerald-100 text-emerald-700 border-emerald-300";
    case "pending_renewal":
      return "bg-amber-100 text-amber-700 border-amber-300";
    case "expired":
      return "bg-red-100 text-red-700 border-red-300";
    default:
      return "bg-gray-100 text-gray-700 border-gray-300";
  }
};

export const getPlanBgGradient = (color) => {
  const gradients = {
    purple: "bg-gradient-to-r from-purple-500 to-purple-600",
    blue: "bg-gradient-to-r from-blue-500 to-blue-600",
    emerald: "bg-gradient-to-r from-emerald-500 to-emerald-600"
  };
  return gradients[color] || "bg-gradient-to-r from-gray-500 to-gray-600";
};
